import axios from 'axios'
import { Dialog, Toast, Notify } from 'vant'
import store from '@/store'
import { getToken, setDingPasswordRequired } from '@/utils/auth'

window.BASE_URL = process.env.VUE_APP_BASE_API

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 300000, // request timeout
  headers: {
    platform: 'h5',
    version: '20250707'
  }
})

function tryHideFullScreenLoading() {
  Toast.clear()
}

function startLoading() {
  Toast({
    type: 'loading',
    duration: 0,
    forbidClick: true,
    message: '加载中...',
    loadingType: 'spinner'
  })
}

var hasLoading = true
let sessionExpiredHandling = false

function createBusinessError(response) {
  const error = new Error((response && response.message) || '请求失败')
  error.code = response && response.code
  error.responseData = response
  return error
}

function redirectToLogin() {
  if (window.location.hash !== '#/login') {
    window.location.hash = '/login'
  }
}

function handleSessionExpired(message) {
  if (sessionExpiredHandling) {
    return
  }

  sessionExpiredHandling = true
  setDingPasswordRequired()
  store
    .dispatch('user/resetToken', {
      requirePassword: true,
      preserveRedirect: true
    })
    .finally(() => {
      redirectToLogin()
      Dialog.alert({
        title: '系统提示',
        message: message || '登录状态已失效，请重新登录'
      })
        .catch(() => {})
        .finally(() => {
          sessionExpiredHandling = false
        })
    })
}

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent
    if (config.loading == undefined || config.loading !== false) {
      startLoading()
    } else {
      hasLoading = false
    }

    if (store.getters.token) {
      config.headers['Authorization'] = 'Bearer ' + getToken()
    }
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    tryHideFullScreenLoading()
    // if (hasLoading !== false) {
    //   tryHideFullScreenLoading()
    // }
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  response => {
    tryHideFullScreenLoading()
    // if (hasLoading !== false) {
    //   tryHideFullScreenLoading()
    // }

    const res = response.data
    if ('arraybuffer' == response.request.responseType) {
      return response
    }
    // if the custom code is not 20000, it is judged as an error.
    if (res.code !== 200) {
      // 50000 token错误
      if (res.code === 50000) {
        // 失效 token 不能再调用退出接口，否则会重复触发鉴权错误。
        handleSessionExpired(res.message)
        return Promise.reject(createBusinessError(res))
      }
      if (res.code == 60000) {
        // 版本提示
        Dialog.confirm({
          title: '系统提示',
          message: res.message
        })
          .then(() => {
            window.location.reload()
          })
          .catch(() => {
            // on cancel
          })
      }
      // Toast.fail(res.message || 'Error')
      Notify({ type: 'danger', message: res.message || 'Error' })
      // return Promise.reject(new Error(res.message || 'Error'))
      return Promise.resolve(res)
    } else {
      return res
    }
  },
  error => {
    tryHideFullScreenLoading()
    // if (hasLoading !== false) {
    //   tryHideFullScreenLoading()
    // }
    console.log('err' + error) // for debug
    if (error.response && error.response.status === 401) {
      const responseData = error.response.data || {}
      handleSessionExpired(responseData.message || error.message)
    } else {
      Notify({ type: 'danger', message: error.message || 'Error' })
    }
    return Promise.reject(error)
  }
)

export default service
